(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/actions.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/actions.js');
"use strict";


(function (svs) {
  'use strict';

  svs.grassroots_partner.actions.SET_TERMS = 'SET_TERMS';
  svs.grassroots_partner.actions.SET_USERNAME = 'SET_USERNAME';
  svs.grassroots_partner.actions.SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
  svs.grassroots_partner.actions.setTerms = checked => ({
    type: svs.grassroots_partner.actions.SET_TERMS,
    checked
  });
  svs.grassroots_partner.actions.setUserName = value => ({
    type: svs.grassroots_partner.actions.SET_USERNAME,
    userName: value
  });
  svs.grassroots_partner.actions.showErrorMessage = message => ({
    type: svs.grassroots_partner.actions.SHOW_ERROR_MESSAGE,
    errorMessage: message
  });
})(svs);

 })(window);